module.exports = "export default __webpack_public_path__ + &quot;2b39f33f5ccfe1d89300b69171d00005.svg&quot;;"